import { productNameTransform } from "@ecco/ui/product-name-transform";

const ECCO_KOLLEKTIVE_OCCASION = "ECCO.KOLLEKTIVE";

type ProductNameContext = {
    name: string;
    occasion?: string;
};

export const resolveProductDisplayName = ({ name, occasion }: ProductNameContext): string => {
    if (occasion === ECCO_KOLLEKTIVE_OCCASION) {
        return name;
    }

    return productNameTransform(name);
};
